import SectionHeader from "../../../util/component/SectionHeader";
import * as React from "react";
import {useLocation} from "react-router-dom";
import {useCallback, useContext, useEffect, useState} from "react";
import { getApplicationById } from "./applicationDetail.actions";
import { AxiosError } from "axios";
import { useRecoilState } from "recoil";
import {IApplicationTabs} from "./models";
import {Box, Tab, Tabs} from "@mui/material";
import Application from "./tabs-section/tabs/Application";
import Documentation from "./tabs-section/tabs/Documentation";
import { applicationInfoState } from "../searchms/state";
import {setSnackbar} from "../../../util/state/globalAction";
import {snackbarTypes} from "../../../util/state/globalVariables";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import {useTranslation} from "react-i18next";

const ApplicationDetail = () => {

    const { dispatchGlobalData } = useContext(GlobalContext);
    const {t} = useTranslation(['network', 'translation']);
    const location: any = useLocation();
    const [applicationData, setApplicationData] = useRecoilState(applicationInfoState)
    const getLastItem = (path:any) => path.substring(path.lastIndexOf('/') + 1)
    // Use State
    const [tab, setTab] = useState<IApplicationTabs>(IApplicationTabs.APPLICATION_DETAIL);

    // Use Callback
    const handleChangeTab = useCallback((event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
    }, []);

    const [isDisabled, setIsDisabled] = useState(false);

    const handleDisable = (status:string) => {
        switch (status) {
            case "Created" : {
                return true;
            }

            case "Rejected by committee" : {
                return true;
            }

            case "Suspended by committee" : {
                return true;
            }
            case "CREATED" : {
                return true;
            }

            case "REJECTED_BY_COMMITTE" : {
                return true;
            }

            case "SUSPENDED_BY_COMMITTEE" : {
                return true;
            }

            default: {
                return false;
            }

        }
    }

    useEffect(()=>{
        if(location.state?.idApplication !== undefined){
            let reqParameters = {
                applicationId: location.state.idApplication
            }
            getApplicationById(reqParameters)
                .then( (res:any) => {
                    setApplicationData(res.application);
                })
                .catch((err: AxiosError) => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('translation:error.tryLater'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                });
        }
        else {
            let idOnReload = getLastItem(location.pathname);
            let reqParameters = {
                applicationId: parseInt(idOnReload)
            }
            getApplicationById(reqParameters)
                .then( (res:any) => {
                    setApplicationData(res.application);

                })
                .catch((err: AxiosError) => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('translation:error.tryLater'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                });
        }
    },[])



    return(
        <>
            <SectionHeader title={t("applicationDetail.title")}/>
            <Box px={2} pt={2}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tab} onChange={handleChangeTab}>
                        <Tab label={t("applicationDetail.title")}/>
                        <Tab disabled={handleDisable(applicationData?.currentStatus)} label={t("applicationDetail.form.label.documents")}/>
                    </Tabs>
                </Box>
                <Box py={3}>
                    {tab === IApplicationTabs.APPLICATION_DETAIL &&
                        <Application/>
                    }
                    {tab === IApplicationTabs.DOCUMENTATION &&
                        <Documentation />
                    }
                </Box>
            </Box>
        </>

    )
}

export default ApplicationDetail;